{
  "decrease": "{fieldLabel} verlagen",
  "increase": "{fieldLabel} verhogen",
  "numberField": "Getalveld"
}
